import { Paper } from '@mui/material'
import { styled } from '@mui/material/styles'
import { MissingData } from './MissingData'
import { MissingParameters } from './MissingParameters'

interface Props {
  missingDataErrors?: Record<string, string>
  invalidParameters?: string[]
}

const ErrorContainer = styled(Paper)`
  margin: 0 auto;
  padding: 2rem;
  width: 75%;
`

const Invalid = ({ invalidParameters, missingDataErrors }: Props) => {
  const hasMissingDataErrors = Boolean(Object.keys(missingDataErrors ?? {}).length)

  return (
    <ErrorContainer>
      {hasMissingDataErrors ? (
        <MissingData errors={missingDataErrors as Record<string, string>} />
      ) : (
        <MissingParameters invalidParameters={invalidParameters as string[]} />
      )}
    </ErrorContainer>
  )
}

export { Invalid }
